import './App.scss'
import { useReducer } from 'react'
import Layout from './Layout'
import { AppData, AppDispatch, appReducer, initialState } from './Model'

export default function App() {
	const [ state, dispatch ] = useReducer(appReducer, initialState)

	return (
		<AppData.Provider value={state}>
			<AppDispatch.Provider value={dispatch}>
				<Layout />
			</AppDispatch.Provider>
		</AppData.Provider>
	)
}
